// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"6532":"ApprovalDetail","7318":"BiosafetyDetail"}[chunkId] || chunkId) + "." + {"1659":"81c62f6f","5725":"414f26a7","6532":"7a3ef5f9","7318":"cf17a582","8214":"571b80da"}[chunkId] + ".chunk.css";
};